import { render } from "./RegionSelect.vue?vue&type=template&id=2ebbb0cb&scoped=true&ts=true"
import script from "./RegionSelect.vue?vue&type=script&lang=ts"
export * from "./RegionSelect.vue?vue&type=script&lang=ts"

import "./RegionSelect.vue?vue&type=style&index=0&id=2ebbb0cb&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebbb0cb"]])

export default __exports__